import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
// name is optional

Vue.use(VueLodash, { lodash });
